@if (comoUser) {
  <div
    class="mb-3 w-full md:rounded-md md:overflow-hidden"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
  >
    <app-como-asset-list-atom
      [assets]="comoUser.assets"
      [heading]="heading | translate"
      [subheading]="subheading"
      [displayCredits]="displayCredits"
      [displayPoints]="displayPoints"
      [displayRedeemableGifts]="displayRedeemableGifts"
      [displayNotRedeemableGifts]="displayNotRedeemableGifts"
      [displayRedeemablePointShop]="displayRedeemablePointShop"
      [displayNotRedeemablePointShop]="displayNotRedeemablePointShop"
      [displayNotUsablePointShop]="displayNotUsablePointShop"
      [creditBalance]="comoUser.credit_balance.monetary"
      [pointsBalance]="comoUser.points_balance.non_monetary"
      (onAssetAdd)="onAssetAdd($event)"
      (onAssetRemove)="onAssetRemove($event)"
    ></app-como-asset-list-atom>
  </div>
}
